import { InjectionToken } from '@angular/core';

export type AppUX = 'ux2' | 'ux3';
export const APP_UX = new InjectionToken<AppUX>('app_ux', {
  factory: () => 'ux3',
});
